window.WSPillSelector = window.WSPillSelector || {
  sync(root, activeButton) {
    if (!root || !activeButton) return;

    const activeBg = root.querySelector('.pill-selector__active-bg');
    if (!activeBg) return;

    activeBg.style.width = `${activeButton.offsetWidth}px`;
    activeBg.style.left = `${activeButton.offsetLeft}px`;
    activeBg.style.display = 'block';
  },

  setActive(root, buttons, index, options = {}) {
    const list = Array.from(buttons || []);
    if (!root || !list.length) return 0;

    const safeIndex = Number.isFinite(index) ? Math.max(0, Math.min(index, list.length - 1)) : 0;
    const { focus = false, onChange } = options;

    list.forEach((button, i) => {
      const isActive = i === safeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
      if (onChange) onChange(button, i, isActive);
    });

    const activeButton = list[safeIndex];
    this.sync(root, activeButton);
    if (focus) activeButton.focus();

    return safeIndex;
  },
};
